// extracted by mini-css-extract-plugin
module.exports = {"container":"Contact_container__Cs1o3","channels":"Contact_channels__A_Fy_"};